export default __webpack_public_path__ + "static/media/Db_4_1.fa14e1e5.png";